var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    { staticClass: "sip-report-banner", attrs: { to: _vm.to } },
    [
      _c(
        "span",
        {
          staticClass: "sip-report-banner__well",
          attrs: { "aria-hidden": "true" },
        },
        [_c("admin-icon", { attrs: { name: _vm.icon, size: 18 } })],
        1
      ),
      _vm._v(" "),
      _c("span", { staticClass: "sip-report-banner__copy" }, [
        _c("span", { staticClass: "sip-report-banner__title" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "sip-report-banner__action" },
        [
          _c("span", { staticClass: "sip-report-banner__view" }, [
            _vm._v(_vm._s(_vm.trans("general.view"))),
          ]),
          _vm._v(" "),
          _c("admin-icon", { attrs: { name: "chevron", size: 14 } }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }